module.exports = __webpack_public_path__ + "img/雪.5e446a54.png";